module.exports = __webpack_public_path__ + "static/download/poster_RGB_eng.jpg?016db467";